import { render, staticRenderFns } from "./SwitchRegions.vue?vue&type=template&id=5ae3a98a&scoped=true&"
import script from "./SwitchRegions.vue?vue&type=script&lang=js&"
export * from "./SwitchRegions.vue?vue&type=script&lang=js&"
import style0 from "./SwitchRegions.vue?vue&type=style&index=0&id=5ae3a98a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae3a98a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ae3a98a')) {
      api.createRecord('5ae3a98a', component.options)
    } else {
      api.reload('5ae3a98a', component.options)
    }
    module.hot.accept("./SwitchRegions.vue?vue&type=template&id=5ae3a98a&scoped=true&", function () {
      api.rerender('5ae3a98a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/Header/SwitchRegions.vue"
export default component.exports